<template>
  <Teleport to="body">
    <transition name="fade">
      <div v-if="visible" class="loading-overlay">
        <div class="loading-content">
          <div class="cloud-container">
            <i class="fa-solid fa-cloud cloud-loader"></i>
            <div class="water-drops">
              <div class="water-drop"></div>
              <div class="water-drop delay-1"></div>
              <div class="water-drop delay-2"></div>
            </div>
          </div>
          <div class="loading-text">{{ text }}</div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  name: 'LoadingOverlay',
  data() {
    return {
      visible: false,
      text: '加载中...'
    }
  },
  mounted() {
    eventBus.on('show-loading', this.handleLoading)
  },
  beforeUnmount() {
    eventBus.off('show-loading', this.handleLoading)
  },
  methods: {
    handleLoading(options) {
      if (options.show) {
        this.text = options.text || '加载中...'
        this.visible = true
      } else {
        this.visible = false
      }
    }
  }
}
</script>

<style scoped>
/* Base Reset for component */
.loading-overlay *, .loading-overlay *::before, .loading-overlay *::after {
  box-sizing: border-box;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(25px) saturate(180%);
  -webkit-backdrop-filter: blur(25px) saturate(180%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--z-loading);
}

.loading-content {
  text-align: center;
  background: rgba(255, 255, 255, 0.35);
  padding: 40px 60px;
  border-radius: 36px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
}

.cloud-container {
  position: relative;
  display: inline-block;
  margin-bottom: 25px;
}

.cloud-loader {
  font-size: 85px;
  color: #007aff;
  animation: cloudFloat 3s ease-in-out infinite;
  filter: drop-shadow(0 8px 15px rgba(0, 122, 255, 0.25));
  display: block;
}

.water-drops {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 80px;
  overflow: hidden;
  pointer-events: none;
}

.water-drop {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -5px;
  width: 10px;
  height: 14px;
  background: #007aff;
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  opacity: 0;
  animation: rainDrop 1.2s linear infinite;
}

.water-drop:nth-child(2) { margin-left: -20px; animation-delay: 0.4s; }
.water-drop:nth-child(3) { margin-left: 10px; animation-delay: 0.8s; }

@keyframes cloudFloat {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-12px) scale(1.02); }
}

@keyframes rainDrop {
  0% { transform: translateY(0) scale(0.6); opacity: 0; }
  20% { opacity: 1; }
  100% { transform: translateY(60px) scale(1); opacity: 0; }
}

.loading-text {
  font-size: 19px;
  font-weight: 800;
  color: #1d1d1f;
  letter-spacing: 0.5px;
  font-family: '爱点风雅黑', sans-serif;
  text-shadow: 0 2px 4px rgba(255, 255, 255, 0.5);
}

/* Transitions */
.fade-enter-active, .fade-leave-active { transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1); }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* Dark Mode */
:global(body.dark-theme) .loading-overlay {
  background: rgba(28, 28, 30, 0.7);
  backdrop-filter: blur(25px) saturate(200%);
}

:global(body.dark-theme) .loading-content {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
}

:global(body.dark-theme) .loading-text {
  color: #f5f5f7;
  text-shadow: none;
}

:global(body.dark-theme) .cloud-loader,
:global(body.dark-theme) .water-drop {
  color: #007aff;
  background: #007aff;
}

/* Mobile adjustments */
@media (max-width: 480px) {
  .loading-overlay {
    background: transparent; /* Clean transparent mask on mobile */
  }
  
  .loading-content {
    background: transparent; /* Remove "white card" on mobile */
    border: none;
    box-shadow: none;
    padding: 20px;
  }
  
  .loading-text {
    color: #1d1d1f;
    font-size: 17px;
  }
  
  body.dark-theme .loading-text {
    color: #f5f5f7;
  }
}
</style>
